<template>
  <div class="videolist">
    <div class="video-banner"></div>
    <div class="container  index-con">
      <div class="index-con-tit">
        <div class="index-con-wd zf">
          <h2>娱人工访</h2>
          <i></i>

          <h4>YINGPAI INTERVIEW</h4>

        </div>

        <div class="clearfix"></div>
      </div>
      <div class="zf-pic-fir" v-for="(item,key) in topList" :key='item.key' v-if="key===0">
        <router-link :to="'/videocontent/'+item.id">
          <img width="1200" height="680" :src="item.picture" :alt="item.name">

          <div class="big-pic-foo">

            <h2 style="margin-left: 30px;">{{item.title}}</h2>

          </div>
        </router-link>
      </div>

      <div class="float-left zf-pic-sec" v-for="(item,key) in topList" :key='item.key' v-if="key===1">
        <router-link :to="'/videocontent/'+item.id" style="display: block;height: 400px; overflow: hidden;">
          <img :src="item.picture" width="670" height="auto"/>
        </router-link>
        <div class="zf-pic-foo">
          <!-- <p>映派专访</p> -->
          <p>{{item.title}}</p>
        </div>

      </div>
      <div class="float-left zf-pic-thr">
        <ul>
          <li v-for="(item,key) in topList" :key='item.key' v-if="key===2" class="">
            <router-link :to="'/videocontent/'+item.id">
              <img :src="item.picture" width="244" height="auto">
            </router-link>
            <div class="zf-pic-foo">
              <!-- <p>映派专访</p> -->
              <p>{{item.title}}</p>
            </div>

          </li>
          <li style="margin-left: 20px;" v-for="(item,key) in topList" :key='item.key' v-if="key===3" class="">
            <router-link :to="'/videocontent/'+item.id">
              <img :src="item.picture" width="244" height="auto">
            </router-link>
            <div class="zf-pic-foo">
              <!-- <p>映派专访</p> -->
              <p>{{item.title}}</p>
            </div>

          </li>
          <li v-for="(item,key) in topList" :key='item.key' v-if="key===4" class="">
            <router-link :to="'/videocontent/'+item.id">
              <img :src="item.picture" width="244" height="auto">
            </router-link>
            <div class="zf-pic-foo">
              <!-- <p>映派专访</p> -->
              <p>{{item.title}}</p>
            </div>

          </li>
          <li style="margin-left: 20px;" v-for="(item,key) in topList" :key='item.key' v-if="key===5" class="">
            <router-link :to="'/videocontent/'+item.id">
              <img :src="item.picture" width="244" height="auto" alt="item.title">
            </router-link>
            <div class="zf-pic-foo">
              <!-- <p>映派专访</p> -->
              <p>{{item.title}}</p>
            </div>

          </li>
          <div class="clearfix"></div>
        </ul>
      </div>
      <div class="clearfix"></div>
      <div class="line-sty"></div>
      <div class="zf-pic-four">
        <ul>
          <li v-for="item in list" :key="item.id">
            <router-link :to="'/videocontent/'+item.id">
              <div class="cover" style="width: 280px;height: 170px;overflow: hidden">
                <img :src="item.picture" style="width: 100%">
              </div>

              <div class="zf-pic-foo">
                <!-- <p>映派专访</p> -->
                <p>{{item.title}}</p>
              </div>
            </router-link>
          </li>
          <div class="clearfix"></div>
        </ul>
      </div>
      <v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false"
              @page-change="pageChange"></v-page>
      <!--<div v-else><p>没有数据</p></div>-->
    </div>
  </div>
</template>

<script>

  import pageNation from './pageNation'

  export default {
    name: 'videolist',
    data() {
      return {
        info: {},
        totalRow: 100,
        pageArr: [],
        pageNum: 1,
        list: [],
        seoList: {
          column_title: '艺人专访'
      },
        topList: []


      }
    },
    components: {
      pageNation
    },
    metaInfo() {
      return {
        title: this.seoList.column_title  + '-打造影视行业优秀的资源聚合服务平台'  || '',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords
        },
          {
            name: 'description',
            content: this.seoList.column_description
          }]
      }
    },
    methods: {
      pageChange(pInfo) {
        pInfo.pageSize = 12//显示count数量
        this.pageNum = pInfo.pageNumber //页码
        this.$http.get('https://api.yopoo.cn/api/v1/visit?page=' + this.pageNum + '&count=' + pInfo.pageSize)
          .then((res) => {
              window.scrollTo(0,0)

              this.list = res.body.data
            this.pageArr = res.body.pagination //返回分页数组
            this.totalRow = res.body.pagination.total
          }, (err) => {
            console.log(err)
          })
        this.info = pInfo

      },
      getSeo() {
        let seoApi = 'https://api.yopoo.cn/api/v1/visit?page=1&count=12'
        this.$http.get(seoApi)
          .then((res) => {
            this.seoList = res.body.metas
            this.column_title = this.seoList.column_title
            this.column_keywords = this.seoList.column_keywords
            this.column_description = this.seoList.column_description
          }, err => {
            console.log(err)
          })
      },
      getTop() {
        let topApi = 'https://api.yopoo.cn/api/v1/hotvisit?count=6'
        this.$http.get(topApi)
          .then((res) => {
            this.topList = res.body.data
          })
      },
      requestData() {
        var api = 'https://api.yopoo.cn/api/v1/visit?page=1&count=12'
        this.$http.get(api).then((response) => {
            this.list = response.body.data
          },
          err => {
            console.log(err)
          }
        )
      }
    },

    beforeMount() {
      // this.requestData()
      this.getSeo()
      this.getTop()
    }
  }
</script>

<style>
  .video-banner {
    background: url("../assets/images/bg-video.jpg") no-repeat center center;
    background-size: 100% 100%;
    height: 430px;
  }

  .big-pic-foo {
    /* width: 1060px; */
    height: 80px;
    line-height: 80px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    position: relative;
    margin-top: -80px;
    background-attachment: fixed;
    overflow: hidden;
  }
  .zf-pic-thr {
    width: 510px;
    float: right;
    height: 470px;
    margin-top: 20px;

  }

  .zf-pic-sec {
    width: 670px;
    height: 470px;
    margin-top: 40px;
  }

  .zf-pic-thr ul li {
    float: left;
    height: 225px;
    width: 245px;
    margin-top: 20px;
  }

  .zf-pic-thr img {
    height: 155px;
  }

  .line-sty {
    border-top: 1px solid #c7c7c7;
    height: 60px;
    margin-top: 60px;
  }

  .zf-pic-four ul li {
    width: 280px;
    float: left;
    margin: 10px 10px;
    transition: all 1s;
  }
  .zf-pic-four ul li:hover{
    box-shadow: 0 7px  10px rgba(0,0,0,.1);
    transition: all .2s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue